// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-placeholder {
  position: relative;
  width: 76px;
  min-height: 100vh;
  z-index: 100;
  transition: width 0.3s ease;
}
.sidebar-placeholder:hover .sidebar {
  position: absolute;
  top: 0;
  left: 0;
  width: 240px;
  box-shadow: 10px 0 30px rgba(0, 0, 0, 0.3);
  height: 100%;
  padding: 16px 16px;
}
.sidebar-placeholder:hover .sidebar__header,
.sidebar-placeholder:hover .sidebar__list-item a span {
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
  transition-delay: 0.1s;
}
@media (max-width: 1200px) {
  .sidebar-placeholder {
    width: 100%;
    min-height: auto;
  }
  .sidebar-placeholder:hover .sidebar {
    position: relative;
    width: 100%;
    box-shadow: var(--container-shadow);
    height: auto;
  }
}

.sidebar {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #131313;
  box-shadow: var(--container-shadow);
  border-radius: 10px;
  padding: 16px 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), padding 0.3s ease, box-shadow 0.3s ease;
}
@media (max-width: 1200px) {
  .sidebar {
    width: 100%;
    height: auto;
    padding: 16px;
    border-radius: 0 0 10px 10px;
    overflow: visible;
  }
}
.sidebar__header {
  display: flex;
  justify-content: center;
  padding: 20px 0;
  color: #fff;
  font-weight: bold;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transform: translateX(-20px);
  transition: all 0.3s ease;
}
@media (max-width: 1200px) {
  .sidebar__header {
    opacity: 1;
    visibility: visible;
    transform: none;
  }
}
.sidebar__wrapper {
  width: 100%;
}
.sidebar__list {
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0;
  margin: 0;
}
@media (max-width: 1200px) {
  .sidebar__list {
    flex-direction: row;
    justify-content: space-around;
  }
}
.sidebar__list-item {
  width: 100%;
  padding: 4px 0;
}
.sidebar__list-item a {
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  color: #fff;
  transition: background 0.2s ease;
  white-space: nowrap;
}
.sidebar__list-item a.active {
  background: var(--primary-color);
}
.sidebar__list-item a svg {
  width: 24px;
  height: 24px;
  min-width: 24px;
  margin-right: 16px;
  flex-shrink: 0;
}
.sidebar__list-item a span {
  opacity: 0;
  visibility: hidden;
  transform: translateX(-15px);
  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease;
}
@media (max-width: 1200px) {
  .sidebar__list-item a span {
    opacity: 1;
    visibility: visible;
    transform: none;
  }
}
.sidebar__list-item a:hover {
  background: var(--primary-color);
  filter: brightness(1.2);
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/Sidebar/Sidebar.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAQA;EACE,kBAAA;EACA,WAPwB;EAQxB,iBAAA;EACA,YAAA;EACA,2BAAA;AAPF;AAWI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAjBmB;EAkBnB,0CAAA;EACA,YAAA;EACA,kBAAA;AATN;AAaI;;EAEE,UAAA;EACA,mBAAA;EACA,wBAAA;EACA,sBAAA;AAXN;AAgBE;EA9BF;IA+BI,WAAA;IACA,gBAAA;EAbF;EAeE;IACE,kBAAA;IACA,WAAA;IACA,mCAAA;IACA,YAAA;EAbJ;AACF;;AAkBA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mCAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,4FACQ;AAhBV;AAoBE;EAhBF;IAiBI,WAAA;IACA,YAAA;IACA,aAAA;IACA,4BAAA;IACA,iBAAA;EAjBF;AACF;AAmBE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EAGA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,yBAAA;AAnBJ;AAqBI;EAdF;IAeI,UAAA;IACA,mBAAA;IACA,eAAA;EAlBJ;AACF;AAqBE;EACE,WAAA;AAnBJ;AAsBE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AApBJ;AAsBI;EAPF;IAQI,mBAAA;IACA,6BAAA;EAnBJ;AACF;AAsBE;EACE,WAAA;EACA,cAAA;AApBJ;AAsBI;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;EACA,gCAAA;EACA,mBAAA;AApBN;AAsBM;EACE,gCCnID;AD+GP;AAuBM;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AArBR;AAwBM;EAEE,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,wEAAA;AAvBR;AAyBQ;EAPF;IAQI,UAAA;IACA,mBAAA;IACA,eAAA;EAtBR;AACF;AAyBM;EACE,gCC7JD;ED8JC,uBAAA;AAvBR","sourcesContent":["@import '../../../styles/_variables';\r\n\r\n// Константы для удобной настройки размеров\r\n$sidebar-collapsed-width: 76px;\r\n$sidebar-expanded-width: 240px;\r\n\r\n// --- КОНТЕЙНЕР-ЗАГЛУШКА ---\r\n// Этот блок всегда в потоке, резервирует место, чтобы контент не прыгал\r\n.sidebar-placeholder {\r\n  position: relative;\r\n  width: $sidebar-collapsed-width;\r\n  min-height: 100vh;\r\n  z-index: 100;\r\n  transition: width 0.3s ease;\r\n\r\n  // Логика раскрытия при наведении\r\n  &:hover {\r\n    .sidebar {\r\n      position: absolute; // Вылетает поверх контента\r\n      top: 0;\r\n      left: 0;\r\n      width: $sidebar-expanded-width;\r\n      box-shadow: 10px 0 30px rgba(0, 0, 0, 0.3);\r\n      height: 100%;\r\n      padding: 16px 16px; // Увеличиваем внутренний отступ при раскрытии\r\n    }\r\n\r\n    // Проявляем скрытые текстовые элементы\r\n    .sidebar__header,\r\n    .sidebar__list-item a span {\r\n      opacity: 1;\r\n      visibility: visible;\r\n      transform: translateX(0);\r\n      transition-delay: 0.1s; // Текст появляется чуть позже начала расширения\r\n    }\r\n  }\r\n\r\n  // Сброс для мобильных устройств (планшеты и ниже)\r\n  @media (max-width: 1200px) {\r\n    width: 100%;\r\n    min-height: auto;\r\n\r\n    &:hover .sidebar {\r\n      position: relative;\r\n      width: 100%;\r\n      box-shadow: var(--container-shadow);\r\n      height: auto;\r\n    }\r\n  }\r\n}\r\n\r\n// --- ВНУТРЕННИЙ САЙДБАР (ВИЗУАЛ) ---\r\n.sidebar {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #131313;\r\n  box-shadow: var(--container-shadow);\r\n  border-radius: 10px;\r\n  padding: 16px 10px; // Узкий паддинг для центровки иконок\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  transition:\r\n          width 0.3s cubic-bezier(0.4, 0, 0.2, 1),\r\n          padding 0.3s ease,\r\n          box-shadow 0.3s ease;\r\n\r\n  @media (max-width: 1200px) {\r\n    width: 100%;\r\n    height: auto;\r\n    padding: 16px;\r\n    border-radius: 0 0 10px 10px;\r\n    overflow: visible;\r\n  }\r\n\r\n  &__header {\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 20px 0;\r\n    color: #fff;\r\n    font-weight: bold;\r\n    white-space: nowrap;\r\n\r\n    // Скрыто в свернутом состоянии\r\n    opacity: 0;\r\n    visibility: hidden;\r\n    transform: translateX(-20px);\r\n    transition: all 0.3s ease;\r\n\r\n    @media (max-width: 1200px) {\r\n      opacity: 1;\r\n      visibility: visible;\r\n      transform: none;\r\n    }\r\n  }\r\n\r\n  &__wrapper {\r\n    width: 100%;\r\n  }\r\n\r\n  &__list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n\r\n    @media (max-width: 1200px) {\r\n      flex-direction: row;\r\n      justify-content: space-around;\r\n    }\r\n  }\r\n\r\n  &__list-item {\r\n    width: 100%;\r\n    padding: 4px 0;\r\n\r\n    a {\r\n      width: 100%;\r\n      padding: 12px;\r\n      border-radius: 8px;\r\n      display: flex;\r\n      align-items: center;\r\n      cursor: pointer;\r\n      text-decoration: none;\r\n      color: #fff;\r\n      transition: background 0.2s ease;\r\n      white-space: nowrap;\r\n\r\n      &.active {\r\n        background: $main;\r\n      }\r\n\r\n      svg {\r\n        width: 24px;\r\n        height: 24px;\r\n        min-width: 24px; // Чтобы иконка не сжималась при анимации\r\n        margin-right: 16px;\r\n        flex-shrink: 0;\r\n      }\r\n\r\n      span {\r\n        // Скрыто в свернутом состоянии\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        transform: translateX(-15px);\r\n        transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease;\r\n\r\n        @media (max-width: 1200px) {\r\n          opacity: 1;\r\n          visibility: visible;\r\n          transform: none;\r\n        }\r\n      }\r\n\r\n      &:hover {\r\n        background: $main;\r\n        filter: brightness(1.2); // Безопасное осветление для CSS переменных\r\n      }\r\n    }\r\n  }\r\n}","$main: var(--primary-color);\r\n$accent:  var(--accent-color);\r\n$additional: var(--additional-color);\r\n$primary: #131313;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
